//window?.experiments = (window.experiments != undefined) ? window.experiments : [];
growthHack_v2 = "default";

var GrowthBookInstance = (function () {
  // private members
  var objects = [];
  let trkId = getCookie("trkId"); //localStorage.getItem('trkid');

  if (!trkId) {
    trkId = uuidv4();
    setCookie("trkId", trkId);
    //localStorage.setItem('trkId', trkId);
  }
  // Private Member
  const gb = new growthbook.GrowthBook({
    apiHost: "https://abtests-proxy.tmrw.in",
    clientKey: "sdk-6i3XIa7a06UHjN",
    enableDevMode: false,
    attributes: {
      id: trkId,
      country: "IN",
      browser: navigator.userAgent,
      url: window.location.pathname,
      company: "Nobero",
    },
    trackingCallback: (experiment, result) => {
      logGtmEvent(
        "experiment_viewed",
        experiment.key,
        result.variationId,
        result.value
      );
    },
  });

  // public members, exposed with return statement
  return {
    getVariant: getVariant,
    loadFeatures: loadFeatures,
  };

  //Public Method
  function getVariant(experiment, variations) {
    return gb.run({ key: experiment, variations: variations });
  }

  async function loadFeatures() {
    return await gb.loadFeatures({ autoRefresh: true });
  }

  function uuidv4() {
    try {
      return crypto.randomUUID();
    } catch (error) {
      console.log("error", error);
      const payload = {
        errorMessage: error.message,
      };
      gaClickEvent("GA_BREAKING_EVENT", payload);
    }
  }

  function setCookie(name, value) {
    const expiresDate = new Date();
    expiresDate.setMonth(expiresDate.getMonth() + 1);

    // Format the expires date in GMT format
    const expires = expiresDate.toUTCString();

    document.cookie =
        name +
        "=" +
        value +
        "; expires=" +
        expires +
        "; path=/";
  }


  function logGtmEvent(event_name, experiment_name, ab_variant, bucket_name) {
    let gaExpObj = {
      event: event_name,
      experiments: JSON.stringify({
        name: experiment_name,
        variant: ab_variant,
        variant_name: bucket_name,
      }),
    };
    dataLayer.push(gaExpObj);
  }

})();
